import * as React from "react";
import { connect } from 'react-redux';

import Icon from "../../common/Icon/Icon";
import TrackableElement from "../TrackableElement";

import { ReactComponent as MessengerIcon } from '../../../images/icons/messenger.svg';
import { ReactComponent as LinkedInIcon } from '../../../images/icons/linkedin.svg';
import { ReactComponent as FacebookIcon } from '../../../images/icons/facebook.svg';

import * as styles from "./FollowUs.module.scss";

const FollowUs = ({ isVisibleAccountLinks }) => (
  <section className={styles.root} style={!isVisibleAccountLinks ? { display: 'none' } : { display: 'block' }}>
    <ul className={styles.container}>
      <li>
        <p className={styles.text}>Follow us</p>
      </li>
      <li>
        <div className={styles.links}>
          <TrackableElement
            element="a"
            eventCategory="social_media"
            eventAction="in"
            href='https://www.linkedin.com/company/flatfycom/about'
            target="_blank"
          >
            <Icon component={LinkedInIcon} />
          </TrackableElement>
        </div>
      </li>
      <li>
        <div className={styles.links}>
          <TrackableElement
            element="a"
            eventCategory="social_media"
            eventAction="fb"
            href='https://www.facebook.com/flatfy'
            target="_blank"
          >
            <Icon component={FacebookIcon} />
          </TrackableElement>
        </div>
      </li>
      <li>
        <div className={styles.links}>
          <TrackableElement
            element="a"
            eventCategory="social_media"
            eventAction="fb"
            href='https://m.me/flatfy'
            target="_blank"
          >
            <Icon component={MessengerIcon} />
          </TrackableElement>
        </div>
      </li>
    </ul>
  </section>
);

const mapStateToProps = state => ({
  isVisibleAccountLinks: state.topNavigationStyles.isVisibleAccountLinks
});

export default connect(mapStateToProps)(FollowUs);
